<template>
  <div class="flex flex-col gap-5">
    <BaseInformation
      v-if="isSrtDevice"
      :information-text="radiatorInformationText"
      status="info"
    />
    <BaseInformation
      v-if="isPlaceholderRadiator"
      information-text="Der ausgewählte Heizkörper wurde noch nicht identifiziert. Bitte
          identifiziere den Heizkörper und fahre im Anschluss mit der Aufnahme
          des HKV fort."
      status="warning"
    />

    <div
      v-if="isSrtDevice && !isEditMode"
      class="rounded-xl border-2 p-4 dark:border-dark-4 dark:bg-dark-3"
      :class="[
        {
          'border-primary-2 dark:border-primary-2 dark:text-primary-2':
            isSrtDevice && !radiatorId,
        },
      ]"
      @click="selectPlaceholderRadiator()"
    >
      <span class="font-bold">Heizkörper </span>(der Heizkörper wird automatisch
      erstellt)
    </div>

    <RadiatorSelectorCard
      v-for="radiator in radiatorsList"
      :key="radiator?.id"
      :radiator="radiator"
      :selected-radiator="radiatorId"
      :select-radiator="selectRadiator"
      data-testId="radiator-card"
    />
  </div>
</template>
<script lang="ts" setup>
import BaseInformation from '@/components/UI/Hint/BaseInformation.vue';
import { computed } from 'vue';
import { Radiator } from '@/models/radiators/Radiator';
import RadiatorSelectorCard from '@/components/Forms/DeviceFormComponents/RadiatorSelector/RadiatorSelectorCard.vue';

interface Props {
  radiatorId?: string;
  radiatorsList: Radiator[];
  isPlaceholderRadiator?: boolean;
  isSrtDevice?: boolean;
  isEditMode?: boolean;
  installationPoint: object;
}

const props = withDefaults(defineProps<Props>(), {
  radiatorId: undefined,
  isEditMode: true,
});

const emit = defineEmits(['update:radiatorId']);

const selectRadiator = (radiator: Radiator) => {
  emit('update:radiatorId', radiator.id);
};
const selectPlaceholderRadiator = () => {
  emit('update:radiatorId', undefined);
};

const radiatorInformationText = computed(() => {
  return props.radiatorsList.length === 0
    ? 'In diesem Raum stehen keine Heizkörper zur Verfügung. Bitte fahren Sie mit der Geräteaufnahme fort, ein Heizkörper wird automatisch erstellt.'
    : 'Wenn Sie das Gerät an einem der vorhandenen Heizkörper installieren möchten, wählen Sie bitte einen anderen Heizkörper aus.';
});
</script>
